import { useEffect, useState } from "react";
import { foodsApi, type Food } from "../api/client";
import { AiKcalButton } from "../components/AiKcalButton";
import { PageHeader } from "../components/PageHeader";

export function FoodsPage() {
  const [foods, setFoods] = useState<Food[]>([]);
  const [name, setName] = useState("");
  const [kcal, setKcal] = useState("");

  const reload = () => foodsApi.list().then(setFoods);

  useEffect(() => {
    reload();
  }, []);

  const onCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    const k = Number(kcal);
    if (!name.trim() || !k) return;
    await foodsApi.create({ name: name.trim(), kcal: k });
    setName("");
    setKcal("");
    reload();
  };

  const onDelete = async (id: string) => {
    await foodsApi.remove(id);
    reload();
  };

  return (
    <div className="page">
      <PageHeader title="カロリーマスター" titleClassName="page-title-half" />

      <form onSubmit={onCreate} style={{ marginBottom: "var(--space-lg)" }}>
        <div className="field">
          <label htmlFor="food-name">食品名</label>
          <input id="food-name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="food-kcal">カロリー (kcal)</label>
          <input
            id="food-kcal"
            inputMode="numeric"
            value={kcal}
            onChange={(e) => setKcal(e.target.value)}
          />
          <AiKcalButton foodName={name} />
        </div>
        <button className="btn-primary" type="submit">
          追加する
        </button>
      </form>

      <h2 className="section-title">登録済み</h2>
      {foods.length === 0 ? (
        <p className="muted">まだ登録されていません。</p>
      ) : (
        foods.map((f) => (
          <div className="list-item" key={f.id}>
            <div className="list-item-main">
              <span className="list-item-title">{f.name}</span>
              <span className="list-item-sub">
                {f.kcal} kcal · 利用 {f.use_count}回
              </span>
            </div>
            <button className="btn-link" onClick={() => onDelete(f.id)}>
              削除
            </button>
          </div>
        ))
      )}
    </div>
  );
}
